/* @ngInject */
export function ProtectiveEquipmentActionsFactory(ProtectiveEquipmentService, ProtectiveEquipmentTestService) {
    return {
        getProtectiveEquipment: function(filter) {
            return function(dispatch) {
                ProtectiveEquipmentService.getPersonalEquipment(filter).then(function(data) {
                    dispatch({
                        type: 'GRID_FETCH',
                        id: 'protectiveEquipmentGrid',
                        items: data.items,
                        itemsCount: filter.status === 'act' ? data.totalActive : data.totalArchive,
                        activeCount: data.totalActive,
                        archiveCount: data.totalArchive
                    });
                });
            };
        },
        getProtectiveEquipmentHistory: function(filter) {
            return function(dispatch) {
                ProtectiveEquipmentService.getEquipmentHistory(filter).then(function(data) {
                    dispatch({
                        type: 'GRID_FETCH',
                        id: 'protectiveEquipmentHistoryGrid',
                        items: data.items,
                        itemsCount: data.total
                    });
                });
            };
        },
        getProtectiveEquipmentTests: function(filter) {
            return function(dispatch) {
                ProtectiveEquipmentTestService.getPersonalEquipmentTests(filter).then(function(data) {
                    dispatch({
                        type: 'GRID_FETCH',
                        id: 'protectiveEquipmentTestsGrid',
                        items: data.items,
                        itemsCount: data.total
                    });
                });
            };
        },
        getProtectiveEquipmentTestReports: function(filter) {
            return function(dispatch) {
                ProtectiveEquipmentTestService.getPersonalEquipmentTests(filter).then(function(data) {
                    dispatch({
                        type: 'GRID_FETCH',
                        id: 'protectiveEquipmentTestReportsGrid',
                        items: data.items,
                        itemsCount: data.total
                    });
                });
            };
        },
        getLeadEquivalences: function() {
            return function(dispatch) {
                ProtectiveEquipmentService.getPersonalLeadEquivalences().then(function(data) {
                    dispatch({
                        type: 'LEAD_EQUIVALENCE_LIST',
                        id: 'equipment',
                        data: data
                    });
                });
            };
        },
        getProtectiveEquipmentTypes: function(parentId, locationUuid) {
            return function(dispatch) {
                ProtectiveEquipmentService.getPersonalEquipmentTypes(parentId, locationUuid).then(function(data) {
                    dispatch({
                        type: 'TYPE_LIST',
                        id: 'equipment',
                        data: data
                    });
                });
            };
        },
        getProtectiveEquipmentSubtypes: function(parentId, locationUuid) {
            return function(dispatch) {
                ProtectiveEquipmentService.getPersonalEquipmentTypes(parentId, locationUuid).then(function(data) {
                    dispatch({
                        type: 'SUBTYPE_LIST',
                        id: 'equipment',
                        data: data
                    });
                });
            };
        }
    };
}
